module.exports = __webpack_public_path__ + "a17d279f/img/mini-logo.18817ee5.svg";